import { TitleWithArrow } from '@payfit/growth-platform-brand-system-v2/components/ButtonV2/TitleWithArrow';
import React from 'react';
import { ButtonV2 } from '../../../../growth-platform-brand-system-v2/src/components/ButtonV2';
import { ButtonTracking } from '../../../../growth-platform-brand-system-v2/src/utils/tracking/ButtonTracking';
import { BlockHeader } from 'libs/growth-platform-brand-system-v2/src/components/BlockHeader';
import { SimpleCard, SimpleCardProps } from '../../components/SimpleCard';
import {
  fontBody,
  fontMegaBodyMedium,
} from '../../styles/typographyNew';
import { classNames } from '../../utils/style';

export interface CardsGridProps {
  title?: string;
  subtitle?: string;
  headingAlignment?: 'left' | 'center' | 'right';
  cardsDesign?: 'default' | 'encapsulated';
  cards: SimpleCardProps[];
}

export const CardsGrid: React.FC<CardsGridProps> = ({
  title,
  subtitle,
  headingAlignment,
  cardsDesign = 'default',
  cards,
}) => {
  const cardsDesignDefault = {
    base: 'w-full bg-white',
    imgContainer: 'rounded-[16px] aspect-[16/10]',
    img: 'h-full w-full object-cover',
    content: 'pl-0 pr-0 pt-20 gap-8',
    title: classNames(fontMegaBodyMedium, 'text-default-title'),
    subtitle: classNames(fontBody, 'text-default-content flex-1'),
  };
  const cardsDesignEncapsulated = {
    base: 'border border-xl w-full shrink-0 rounded-24 border-[#F9FAFB] bg-white p-16 shadow-[0_6px_20px_-4px_rgba(4,32,64,0.08)] box-border gap-16',
    content: 'flex flex-col p-16 gap-12',
    title:
      'text-default-title line-clamp-2 text-24 font-sansDisplay font-medium leading-[120%]',
    subtitle: classNames(fontBody, 'text-default-content flex-1'),
    img: 'w-full h-full object-cover',
    imgContainer: 'relative w-full overflow-hidden',
  };
  return (
    <div className="CardsGrid">
      {(title || subtitle) && (
        <div className="pb-48">
          <BlockHeader
            title={title}
          subtitle={subtitle}
            headingAlignment={headingAlignment}
          />
        </div>
      )}
      <div
        className={classNames(
          'flex flex-col gap-40',
          'md:grid md:grid-cols-2',
          'lg:grid-cols-3',
        )}
      >
        {cards?.map((card, index) => {
          const cta = card.cta?.[0];
          const encapsulatedCardDesign = {
            ...cardsDesignEncapsulated,
            base: classNames(
              cardsDesignEncapsulated.base,
              cta && 'hover:shadow-[0_12px_24px_-6px_rgba(4,32,64,0.1)] transition-all duration-150 ease-linear'
            ),
          };
          const cardDesign = cardsDesign === 'default' ? cardsDesignDefault : encapsulatedCardDesign;
          return (
            <ButtonTracking
              component={SimpleCard}
              key={index}
              title={card.title}
              subtitle={card.subtitle}
              cta={
                cta ? <ButtonV2 {...cta} variant="minimal" as="div"><TitleWithArrow {...cta} /></ButtonV2> : null
              }
              as={cta?.as || 'div'}
              draggable={false}
              href={cta?.href}
              to={cta?.to}
              image={{
                ...card.image,
                width: Number(card.image.width),
                height: Number(card.image.height),
                sizes:
                  '(max-width: 768px) 358px, (max-width: 1280px) 391px, (max-width: 1440px) 389px, 391px',
                pixelDensity: 'image_with_text',
              }}
              classObject={cardDesign}
            />
          );
        })}
      </div>
    </div>
  );
};
